import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
  DataGridSemHeader,
} from '../../../components/index';
import {
  validateObject,
  trataMensagensErro,
} from '../../../utils/requests';
import Masks from '../../../utils/masks';
import validarCNPJ from '../../../utils/validator/cnpjValidator';

class ModalCadastroPeriodos extends Component {
  static getDerivedStateFromProps(props, state) {
    const { validadeCampos } = { ...state };
    if (props.periodo && !state.didProps) {
      if (props.errosPeriodo) {
        props.errosPeriodo.forEach((item) => {
          validadeCampos[item.atributo] = false;
        });
        return ({
          periodo: { ...props.periodo },
          validadeCampos,
          errosPeriodo: props.errosPeriodo,
          touched: true,
          didProps: true,
        });
      }
      return ({ periodo: { ...props.periodo }, touched: true, didProps: true });
    }
    return null;
  }

  constructor(props) {
    super();
    const state = this.getInitialState();
    if (props.periodo) {
      const { validadeCampos } = { ...state };
      Object.keys(validadeCampos).forEach((key) => {
        validadeCampos[key] = true;
      });
      state.validadeCampos = validadeCampos;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      periodo: {
        cnpj: null,
        dataCriacaoRpps: null,
        dataEncerramentoRpps: null,
      },
      touched: false,
      validadeCampos: {
        cnpj: false,
        dataCriacaoRpps: false,
        // dataEncerramentoRpps: false,
      },
      didUpdate: false,
      didProps: false,
      errosPeriodo: null,
      estadoFormulario: 'inicial',
      cnpj: null,
    };
    return initialState;
  }

  componentDidMount() {
    this.popularCnpj();
  }

  popularCnpj = () => {
    const { periodo } = { ...this.state };
    periodo.cnpj = this.props.cnpj;
    this.setState({
      periodo: {
        ...periodo,
      },
    });
  }

  formularioProntoParaEnvio = () => (
    validateObject(this.state.validadeCampos)
  )

  resetState = () => {
    this.setState(this.getInitialState());
    this.props.onHide();
    this.props.resetPeriodo();
  }

handleButton = () => {
  const cnpjValido = validarCNPJ(this.state.periodo.cnpj);
  if (!cnpjValido) {
    trataMensagensErro(['CNPJ Inválido. Informe um CNPJ válido.']);
  } else {
    const touched = true;
    this.setState({ ...this.state, touched }, this.handleEnviar);
  }
}

  handleEnviar = () => {
    this.props.addPeriodo(this.state.periodo, this.props.periodo);

    if (this.state.errosOrgaoVinculado) {
      this.props.validacaoErrosOrgaoVinculado(this.state.errosOrgaoVinculado);
    }
    this.resetState();
  }

  handleChange = (changeObj, name) => {
    const { acao } = { ...this.props };
    let { estadoFormulario } = { ...this.state };
    // const validadeCampos = { ...this.state };

    if (acao === 'novo' && this.state.errosOrgaoVinculado && this.state.errosOrgaoVinculado.length >= 1) {
      estadoFormulario = 'alterado';
    }
    // if (!this.props.habilitarCampoCpf) {
    //   validadeCampos.cnpj = true;
    // }
    this.setState({
      periodo: {
        ...this.state.periodo,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
      estadoFormulario,
    });
  }

  // Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
  desabilitaInput = listaAcoesEditaveis => (
    // if (this.props.consulta) {
    //   return true;
    // }
    !listaAcoesEditaveis.includes(this.props.acaoModal)
  )

  // Escolhe o titulo do modal baseado na acao
  determinaTitulo = () => {
    let titulo;
    switch (this.props.acaoModal) {
      case 'edicao': titulo = 'Edição de Período';
        break;
      default: titulo = 'Inclusão de Períodos';
    }
    return titulo;
  }

  handleClose = () => {
    this.setState(this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));
  }

  render() {
    const modalContent = (
      <React.Fragment>
        <DataGridSemHeader title="" icon="ico-doc-book" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={!this.props.habilitarCampoCpf}
                error={!this.state.periodo.cnpj}
                // integer
                label="CNPJ"
                mask={Masks.cnpj}
                onChange={e => this.handleChange(e, 'cnpj')}
                required
                showMask
                touched={this.state.touched}
                value={this.state.periodo.cnpj}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={(!this.props.auth.checkPermission(['analisar-negocio-sprev']))}
                mask={Masks.date}
                label="Data de Criação"
                error={!this.state.periodo.dataCriacaoRpps}
                touched={this.state.touched}
                maxLength="16"
                value={this.state.periodo.dataCriacaoRpps}
                required={(this.props.auth.checkPermission(['analisar-negocio-sprev']))}
                onChange={e => this.handleChange(e, 'dataCriacaoRpps')}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={(!this.props.auth.checkPermission(['analisar-negocio-sprev']))}
                mask={Masks.date}
                label="Data de Encerramento"
                error={!this.state.periodo.dataEncerramentoRpps}
                touched={this.state.touched}
                maxLength="16"
                value={this.state.periodo.dataEncerramentoRpps}
                // required={(this.props.auth.checkPermission(['analisar-negocio-sprev']))}
                onChange={e => this.handleChange(e, 'dataEncerramentoRpps')}
              />
            </Grid>
          </div>
        </DataGridSemHeader>
      </React.Fragment>
    );

    const modalFooter = (
      <React.Fragment>
        <div className="right">
          <Button
            title="Cancelar"
            onClick={this.resetState}
            hint="Cancelar"
          />
          {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
            <Button
              className="dtp-primary"
              disabled={!this.formularioProntoParaEnvio()}
              title={this.props.periodo ? 'Salvar' : 'Adicionar'}
              onClick={(this.handleButton)}
              hint={this.props.periodo ? 'Salvar período' : 'Adicionar período'}
            />
          : ''}
        </div>
      </React.Fragment>
    );

    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.resetState}
        showTitle
        size="lg"
        title={this.determinaTitulo()}
      />
    );
  }
}

ModalCadastroPeriodos.propTypes = {
  showModal: PropTypes.func,
  cnpj: PropTypes.string.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalCadastroPeriodos;



// WEBPACK FOOTER //
// ./src/pages/cadastros/PeriodosRppsUniao/ModalCadastroPeriodos.jsx